/* Smuklia : menu et recherche de l'en-tête copié de Mirelia, sans les scripts du thème Shrine.
   Les <details> s'ouvrent seuls (CSS .no-js de Mirelia) ; ici on les referme. */
(function () {
  function fermer(d) { if (d) d.removeAttribute('open'); }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var bouton = t.closest('.menu-drawer__close-btn, .search-modal__close-button');
    if (bouton) { e.preventDefault(); fermer(bouton.closest('details')); return; }
    if (t.classList.contains('modal-overlay')) { fermer(t.closest('details')); return; }
    document.querySelectorAll('.section-header details[open]').forEach(function (d) {
      if (!d.contains(t)) fermer(d);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.section-header details[open]').forEach(fermer);
  });
  document.querySelectorAll('.header__search details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      var champ = d.querySelector('input[type="search"]');
      if (champ) setTimeout(function () { champ.focus(); }, 60);
    });
  });
})();
